import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

import Home from './views/Homepage'
import Login from './views/Login'

Vue.use(VueRouter);
Vue.config.productionTip = false

Vue.directive('wheel', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        el.removeEventListener('wheel', f)
      }
    }
    el.addEventListener('wheel', f)
  }
})


export const bus = new Vue();

const router = new VueRouter({
  routes: [
    { name: 'home', path: '/', component: Home, props: true },
    { path: '/login', component: Login, props: true}
  ]
});


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
